<template>
  <div>
    <vs-popup title="تغییر نام پلن" :active.sync="showModal">
      <form>
        <vs-input
          class="inputx mb-4 mt-1"
          v-model="modelModify.name"
          name="[promoterPlanName"
          :label="$t('Title')"
          v-validate="'required'"
        />
        <vs-button
          type="filled"
          class="float-right mb-4"
          @click.prevent="submitForm"
          :disabled="disabled"
          >{{ $t("Save") }}</vs-button
        >
      </form>
    </vs-popup>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "saleManagement_BasicDefinitions_SalesPartnerPlan_ModifyPopup",
  props: {
    show: { default: false },
    modelModify: {},
  },
  data() {
    return {
      disabled: false,
    };
  },
  computed: {
    showModal: {
      get: function () {
        return this.show;
      },
      set: function () {
        this.$emit("close");
      },
    },
  },
  methods: {
    ...mapActions({
      editNamePromoterPlan: "SalesPartnerPlan/editNamePromoterPlanApi",
    }),
    submitForm() {
      this.editNamePromoterPlan(this.modelModify).then(() => {
        this.$swal({
          position: "center-center",
          type: "success",
          text: "رکورد مورد‌نظر با موفقیت ویرایش شد!",
          showConfirmButton: false,
          timer: 2000,
        });
        this.$emit("finish");
        this.modelModify = {};
        this.disabled = false;
      });
    },
  },
};
</script>
